import React from "react"
import "./modal-educational.scss"
import { infoModal } from "./infoModal"

import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import { jsonToHash } from "../../../utils/crypto"

const ModalEducational = ({ modalView = 0, handleNext }) => {
  console.log("this is modal view", modalView)
  const userInfo = getUserInfo()
  const modalMetrics = modalView + 1
const handleClick = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: `Interacciones_Tips_nivel`+modalMetrics+`_Vmatch`,
    label,
    action:'view',
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}
  switch (modalView) {
    case 0:
      handleClick('¿Sabías qué?')
      break;
      case 1:
        handleClick('La Zona V')
        break;
        case 2:
          handleClick('¡Viva la vulva!')
          break;
          case 3:
          handleClick('¡disfruta de ser mujer!')
          break;
          case 4:
          handleClick('¡Sí! La menstruación es normal')
          break;
    default:
      break;
  }





  return (
    <div className="modal-educational">
      <div className="modal-educational-container">
        <div className="wrapper-star">
          <div className= {`modal-educational__content ` + infoModal[modalView].clase }>
            {infoModal[modalView].txt}
            <img src={infoModal[modalView].img} alt="Imagen vulva" />
            <button
              className="modal-educational__content__button btn-primary"
              onClick={() => {
                handleNext()
              }}
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalEducational
